import { TicketIcon } from "@phosphor-icons/react"
import { GiftIcon } from "lucide-react"
import { TextRevealCard } from "@/components/aceternityui/text-reveal-card"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogHeaderIcon,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"

export function CouponCodeButton() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          size="icon"
          variant="outline"
          className="size-[38px] rounded-full text--foreground transition-all"
        >
          <GiftIcon className="animate-wiggle" />
        </Button>
      </DialogTrigger>

      <DialogContent className="sm:max-w-xl sm:rounded-xl">
        <DialogHeader className="mb-4 flex flex-col items-center">
          <DialogHeaderIcon icon={<TicketIcon />} variant="primary" size="lg" className="mb-4" />
          <DialogTitle>Exclusive Launch Coupon</DialogTitle>
          <DialogDescription className="max-w-md text-center">
            You&apos;ve discovered our exclusive launch special! <br />
            Grab the coupon code below and get 10% off at checkout.
          </DialogDescription>
        </DialogHeader>

        <TextRevealCard text="Hover to reveal" revealText="FIRST100" className="-m-3 w-auto" />
      </DialogContent>
    </Dialog>
  )
}
